import { render, staticRenderFns } from "./AdmissionFormOffline.vue?vue&type=template&id=121aefd3"
import script from "./AdmissionFormOffline.vue?vue&type=script&lang=js"
export * from "./AdmissionFormOffline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports